export const pageUrl = "https://site.gcores.com/spark"
export const siteUrl = "https://www.gcores.com"
export const aliossUrl = "https://site.gcores.com"
export const imageUrl = "https://image.gcores.com"


export const tagId = "20895"
export const collectionId = '92'